import * as Actions from '../actions';
import moment from 'moment'

const initialState = {
    instructorList: [],
    currentInstructor: {
        FirstName: '',
        LastName: '',
        Address: '',
        City: '',
        State: '',
        Zip: '',
        Phone: '',
        Email: '',
        Active: 0,
        CreateAuthID: 0,
        LastEditAuthID: 0,
        CreationDate: '',
        LastEditDate: '',
        Password: '',
        PasswordConfirm: '',
        related_auth_id: 0
    },
    editInfo: {
        CreationDate: '',
        LastEditDate: '',
        CreateAuthEmail: '',
        LastEditAuthEmail: ''
    },
    roles: [],
    allCompanies: [],
    currentInstructorCompanyList: [],
    dayEvents: [],
    qualifications: [],
    allQualifications: [],
    qualificationAssetList: [],
    deleteAllowed: false,
    upcomingCourses: [],
    events: [],
    dayEvents: [],
    dayUnscheduledEvents: [],
    eventsToGrade: []
}

const instructorReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_INSTRUCTOR_LOADED):
            {
                return {
                    ...state,
                    isInstructorLoaded: action.payload
                }
            }

        case (Actions.UPDATE_INSTRUCTOR_FORM):
            {
                return {
                    ...state,
                    currentInstructor: { ...state.currentInstructor, ...action.payload },
                }
            }
        case (Actions.GET_INSTRUCTOR):
            {
                return {
                    ...state,
                    currentInstructor: { ...initialState.currentInstructor, ...action.payload, instructor_loaded: true }
                };
            }

        case (Actions.DELETE_INSTRUCTOR):
            {
                return {
                    ...state,
                    currentInstructor: { instructor_loaded: false },
                    instructorList: state.instructorList.filter((instructor) => instructor.instructor_id !== action.payload) // Removes Corresponding instructor in instructorList
                };
            }

        case (Actions.GET_RELATED_DATA):
            {
                return {
                    ...state,
                    currentInstructorCompanyList: action.payload.companies,
                    roles: action.payload.roles,
                    currentInstructor: {
                        ...state.currentInstructor,
                        related_auth_id: action.payload.auth_id
                    },
                    editInfo: action.payload.edit_info,
                    upcomingCourses: action.payload.upcomingCourses,
                    deleteAllowed: action.payload.deleteAllowed
                }
            }

        case (Actions.GET_INSTRUCTOR_LIST):
            {
                return {
                    ...state,
                    instructorList: action.payload
                };
            }
        case (Actions.GET_ALL_COMPANIES):
            {
                return {
                    ...state,
                    allCompanies: action.payload
                }
            }
        // case (Actions.GET_COURSE_PREVIEW):
        //     {
        //         if (state.coursePreviewData.filter(c => c.course_id === action.payload.course_id).length > 0) {
        //             return { ...state }
        //         }
        //         return {
        //             ...state,
        //             coursePreviewData: state.coursePreviewData.concat(action.payload.lessons)
        //         }
        //     }
        // case (Actions.GET_MODULE_PREVIEW):
        //     {
        //         if (state.modulePreviewData.filter(m => m.module_id === action.payload.module_id).length > 0) {
        //             return { ...state }
        //         }
        //         return {
        //             ...state,
        //             modulePreviewData: state.modulePreviewData.concat(action.payload.lessons)
        //         }
        //     }
        // case (Actions.GET_SAVED_EVENTS):
        //     {
        //         return {
        //             ...state,
        //             events: action.payload.map(lesson => {
        //                 let newDate = new Date(moment(lesson.LessonDate).format('YYYY-MM-DD HH:mm:ss'))
        //                 // let endTime = new Date(moment(lesson.Date).add(4,'hours').format('YYYY-MM-DD HH:mm:ss'))
        //                 return {
        //                     // Event object format for React Calendar to read
        //                     id: lesson.instructor_calendar_day_id,
        //                     title: lesson.LessonName,
        //                     allDay: true,
        //                     start: newDate,
        //                     end: newDate,
        //                     //custom event component info
        //                     courseName: lesson.CourseName,
        //                     eventType: 'existingEvent',
        //                     instructor_calendar_day_id: lesson.instructor_calendar_day_id,
        //                     instructor_calendar_course_id: lesson.instructor_calendar_course_id,
        //                     instructor_calendar_module_id: lesson.instructor_calendar_module_id,
        //                     selected: false,
        //                     // selected: state.selectedEventData.selected_calendar_course_id === lesson.instructor_calendar_course_id ? true : false,
        //                     // Information needed to save instructor calendar
        //                     course_lesson_rel_id: lesson.course_lesson_rel_id,
        //                     course_id: lesson.course_id,
        //                     module_id: lesson.module_id,
        //                     lesson_id: lesson.lesson_id
        //                 }
        //             })
        //         }
        //     }

        case (Actions.GET_INSTRUCTOR_SCHEDULE):
            {
                let getEventType = (course_id, module_id) => {
                    if (course_id) {
                        return 'Course'
                    }
                    else if (module_id) {
                        return 'Module'
                    }
                    return 'Lesson'
                }
                return {
                    ...state,
                    events: action.payload.map(lesson => {
                        let newDate = new Date(moment(lesson.LessonDate).format('YYYY-MM-DD HH:mm:ss'))
                        return {
                            // Event object format for React Calendar to read
                            id: lesson.company_calendar_day_id,
                            title: lesson.LessonName,
                            allDay: true,
                            start: newDate,
                            end: newDate,
                            //custom event component info
                            courseName: lesson.CourseName,
                            eventType: 'full' + getEventType(lesson.company_calendar_course_id, lesson.company_calendar_module_id),
                            // company_calendar_day_id: lesson.company_calendar_day_id,
                            // company_calendar_course_id: lesson.company_calendar_course_id,
                            // company_calendar_module_id: lesson.company_calendar_module_id,
                            // selected: false,
                            color: lesson.Color,
                            // Information needed to save company calendar
                            // course_lesson_rel_id: lesson.course_lesson_rel_id,
                            // course_id: lesson.course_id,
                            // module_id: lesson.module_id,
                            // lesson_id: lesson.lesson_id
                        }
                    })
                }
            }
        case (Actions.GET_DAY_EVENTS):
            {
                const dayEventList = action.payload.map(event => {
                    return {
                        id: event.company_calendar_event_id,
                        title: event.EventName,
                        allDay: false,
                        start: new Date(event.StartTime),
                        end: new Date(event.EndTime),
                        // custom event component info
                        courseName: event.CourseName,
                        category: event.assignment_id ? 'category-assignment' : 'category-quiz',
                        EventType: event.assignment_id ? 'assignment' : 'quiz',
                        color: event.Color || '#2D323E',
                        Unscheduled: event.Unscheduled
                    }
                })
                return {
                    ...state,
                    dayEvents: dayEventList
                }
            }
        case (Actions.TOGGLE_COMPANY):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCompany = state.allCompanies.filter((company) => company.company_id === action.payload.company.id)
                    return {
                        ...state,
                        currentInstructorCompanyList: state.currentInstructorCompanyList.concat(newCompany),
                    }
                }
                else {
                    return {
                        ...state,
                        currentInstructorCompanyList: state.currentInstructorCompanyList.filter((company) => company.company_id !== action.payload.company.id),
                        qualifications: state.qualifications.filter(qual => qual.company_id != action.payload.company.id)
                    }
                }
            }
        case (Actions.GET_INSTRUCTOR_QUALIFICATIONS):
            {
                return {
                    ...state,
                    qualifications: action.payload.map(q => {
                        return {
                            ...q,
                            pending: q.pending === 1 ? true : false,
                        }
                    })
                }
            }
        case (Actions.GET_ALL_QUALIFICATIONS):
            {
                return {
                    ...state,
                    allQualifications: action.payload
                }
            }
        case (Actions.HANDLE_QUALIFICATION_SELECT):
            {
                return {
                    ...state,
                    qualifications: state.qualifications.map(q => {
                        if (q.qualification_id === action.payload) {
                            return {
                                ...q,
                                active: !q.active,
                                pending: false,
                                Approved: !q.Approved
                            }
                        }
                        return {
                            ...q
                        }
                    })
                }
            }

        case (Actions.HANDLE_QUALIFICATION_TIME_CHANGE):
            {
                const updateData = { [action.payload.column]: action.payload.value }
                return {
                    ...state,
                    qualifications: state.qualifications.map(q => {
                        if (q.qualification_id === action.payload.qual.qualification_id) {
                            return {
                                ...q,
                                ...updateData
                            }
                        }
                        return {
                            ...q
                        }
                    })
                }
            }
        case (Actions.DELETE_QUALIFICATION):
            {
                // return {
                //     ...state,
                //     qualifications: state.qualifications.map(qual => {
                //         if (qual.qualification_id === action.payload.qualification_id) {
                //             // if (qual.new) {
                //             //     return null
                //             // }
                //             return {
                //                 ...qual,
                //                 deleted: true
                //             }
                //         }
                //         return { ...qual }
                //     })
                // }
                return {
                    ...state,
                    qualifications: state.qualifications.filter(qual => qual.qualification_id != action.payload.qualification_id)
                }
            }
        case (Actions.ACCEPT_QUALIFICATION):
            {
                return {
                    ...state,
                    qualifications: state.qualifications.map(q => {
                        if (q.qualification_id === action.payload.qualification_id) {
                            return {
                                ...q,
                                pending: false,
                                Approved: 1,
                            }
                        }
                        return {
                            ...q
                        }
                    })
                }
            }

        case (Actions.UPDATE_QUALIFICATION_ASSET):
            {
                return {
                    ...state,
                    qualificationAssetList: action.payload === 'clear' ? [] : state.qualificationAssetList.concat(action.payload)
                }
            }

        case (Actions.ADMIN_ADD_QUALIFICATION):
            {
                const qualification = action.payload.qualification
                return {
                    ...state,
                    qualifications: state.qualifications.concat({
                        Approved: 1,
                        CompanyName: qualification.CompanyName,
                        EndDate: action.payload.end,
                        isAsset: qualification.RequireAsset,
                        QualificationDescription: qualification.QualificationDescription,
                        QualificationName: qualification.QualificationName,
                        StartDate: action.payload.start,
                        company_id: qualification.company_id,
                        instructor_id: action.payload.instructor_id,
                        instructor_qualification_id: null,
                        pending: false,
                        qualification_id: qualification.qualification_id,
                        new: true,
                        assetList: action.payload.assets
                    })
                }
            }

        case (Actions.ADD_ASSET_TO_LIST):
            {
                return {
                    ...state,
                    qualificationAssetList: state.qualificationAssetList.concat(action.payload)
                }
            }

        case (Actions.DROP_ASSET_FROM_LIST):
            {

                return {
                    ...state,
                    qualificationAssetList: state.qualificationAssetList.filter(a => a.insert_id != action.payload.insert_id)
                }
            }
        
        case (Actions.GET_DAY_UNSCHEDULED_EVENTS):
            {
                return {
                    ...state,
                    dayUnscheduledEvents: action.payload
                }
            }

        case (Actions.GET_EVENTS_TO_GRADE):
            {
                return {
                    ...state,
                    eventsToGrade: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
}

export default instructorReducer;


// WEBPACK FOOTER //
// src/main/content/instructor/store/reducers/instructor.reducer.js